import React, { useEffect } from "react";
import SupportingDocumentsComponent from "../../components/applicationComponents/supportingDocuments/SupportingDocumentsComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";

export default function SupportingDocumentsPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Supporting Documents",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <SupportingDocumentsComponent disabled={false} />
    </>
  );
}
